// extracted by mini-css-extract-plugin
module.exports = {"bundle":"bundle_bundle__2I8ca","trash":"bundle_trash__2H968"};